class WokineSeo {
  constructor(debugMode = false) {
    this.debugMode = debugMode;
    this.debugMode && console.log("WokineSeo initialized");
  }
  optimize(page) {
    this.debugMode && console.time("SeoOptimizer");
    this.currentHead = document.querySelector("head");
    this.nextPage = page;
    this.debugMode && console.log("optimizing SEO");
    this.changeTitle();
    this.changeMetas();
    this.changeCanonical();
    this.changeAlternate();
    this.debugMode && console.timeEnd("SeoOptimizer");
  }
  changeTitle() {
    this.debugMode && console.log("changing title");
    const title = this.nextPage.querySelector("title");
    if (!title)
      return;
    document.title = title.innerText;
  }
  changeMetas() {
    this.debugMode && console.log("changing metas");
    const oldMetas = this.currentHead.querySelectorAll("meta");
    const newMetas = this.nextPage.querySelectorAll("meta");
    this.debugMode && console.log("newMetas", newMetas);
    if (oldMetas) {
      this.removeOldElements(oldMetas);
    }
    if (!newMetas)
      return;
    this.attachNewElements(newMetas);
  }
  changeCanonical() {
    this.debugMode && console.log("changing canonical");
    const oldCanonicals = this.currentHead.querySelectorAll('link[rel="canonical"]');
    const newCanonicals = this.nextPage.querySelectorAll('link[rel="canonical"]');
    this.debugMode && console.log("newCanonicals", newCanonicals);
    if (oldCanonicals) {
      this.removeOldElements(oldCanonicals);
    }
    if (!newCanonicals)
      return;
    this.attachNewElements(newCanonicals);
  }
  changeAlternate() {
    this.debugMode && console.log("changing alternate");
    const oldAlternates = this.currentHead.querySelectorAll('link[rel="alternate"]');
    const newAlternates = this.nextPage.querySelectorAll('link[rel="alternate"]');
    if (oldAlternates) {
      this.removeOldElements(oldAlternates);
    }
    if (!newAlternates)
      return;
    this.attachNewElements(newAlternates);
  }
  attachNewElements(elements) {
    this.debugMode && console.log("attaching to new page");
    elements.forEach((element) => {
      this.currentHead.appendChild(element);
    });
  }
  removeOldElements(elements) {
    elements.forEach((element) => {
      element.remove();
    });
  }
}
export {
  WokineSeo as default
};
